import { PayableStatus } from "../../api/queries";

const STATUS_META: Record<PayableStatus, { label: string; className: string }> =
  {
    pending_approval: {
      label: "Awaiting approval",
      className: "bg-amber-100 text-amber-700 ring-amber-200",
    },
    approved: {
      label: "Approved",
      className: "bg-blue-100 text-blue-700 ring-blue-200",
    },
    paid: {
      label: "Paid",
      className: "bg-emerald-100 text-emerald-700 ring-emerald-200",
    },
  };

export const PaymentStatusBadge = ({ status }: { status: PayableStatus }) => {
  const meta = STATUS_META[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ring-1 ring-inset whitespace-nowrap ${meta.className}`}
    >
      {meta.label}
    </span>
  );
};

export const PAYABLE_STATUS_LABELS = STATUS_META;
